module.exports = __webpack_public_path__ + "media/images/sr_register03-32c27a56.svg";